exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Music__body___4OVnQ {\n  padding: 0 8px;\n  width: 100%;\n}\n\n@media (min-width: 720px) {\n  .Music__body___4OVnQ {\n    width: 720px;\n  }\n}\n\n.Music__p___2npbI,\n.Music__playlistLink___3LKMU {\n  padding: 0 8px;\n}\n\n.Music__playlistLink___3LKMU {\n  font-size: 14px;\n  font-style: italic;\n  margin-top: 8px;\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"body": "Music__body___4OVnQ",
	"p": "Music__p___2npbI",
	"playlistLink": "Music__playlistLink___3LKMU"
};